/* Brake House — self-serve JACKET size recommender (PDP inline + Size Guide standalone).
 *
 * Client-side port of the jacket branch of the CS sizing engine
 * (Brake House CS automation/app-scripts/v7_boot_insole/Size_Recommendation_v7_FULL.gs:
 *  JACKET_HW_TABLE, BH_SIZE_MAP, getChartSize_, JACKET_MODEL_OFFSET, shiftJacketUsSize_,
 *  JACKET_LABEL_BASE, jacketLabelForUs_).
 *
 * The four data blocks below are GENERATED from the engine file by
 * scratchpad/gen_jacket_widget.js and guarded by app-scripts/verify-jacket-hw.mjs.
 * Do not hand-edit the table; edit the engine and regenerate.
 *
 * What it does:
 *   height + weight  -> H/W grid -> US numeric size -> per-model fit offset -> alpha size
 *   ... on the model's own label ladder: most jackets call a US 34 "S", six models (J-24,
 *   Motorist, Archetype, G-1, both Single Sport) call a US 36 "S", so the same body gets a
 *   label one step smaller there (2026-09-13: J-24 183cm/74kg is an L, not an XL).
 *   optional "usual size" (alpha only, so there is no EU/US ambiguity) confirms or flags it
 *   snaps to a size this product actually sells (read off the Size chips), auto-selects it,
 *   and writes hidden cart properties so CS sees what the shopper entered.
 *
 * Deliberately NOT collected: chest and shoulder. The garment-measurement formula that used
 * them reads ~1.5 sizes high (customers measure shoulder seam-to-seam); as of 2026-09-12 the
 * engine treats them as reference only, so the widget does not ask.
 */
(function () {
  "use strict";

  // ======================= ENGINE (generated) =======================
var JACKET_HW_TABLE = [
  { h_min: 155, h_max: 156.9, w_map: [[40, 67.4, 34], [67.5, 75.9, 36], [76, 84.4, 38], [84.5, 92.9, 40], [93, 100.9, 42], [101, 109.4, 44], [109.5, 118.4, 46], [118.5, 160, 48]] },
  { h_min: 157, h_max: 158.9, w_map: [[40, 66.4, 34], [66.5, 75.4, 36], [75.5, 83.4, 38], [83.5, 91.9, 40], [92, 99.9, 42], [100, 108.4, 44], [108.5, 117.4, 46], [117.5, 160, 48]] },
  { h_min: 159, h_max: 160.9, w_map: [[40, 65.9, 34], [66, 74.4, 36], [74.5, 82.9, 38], [83, 90.9, 40], [91, 98.9, 42], [99, 107.9, 44], [108, 116.9, 46], [117, 160, 48]] },
  { h_min: 161, h_max: 162.9, w_map: [[40, 64.9, 34], [65, 73.4, 36], [73.5, 81.9, 38], [82, 90.4, 40], [90.5, 98.4, 42], [98.5, 106.9, 44], [107, 115.9, 46], [116, 160, 48]] },
  { h_min: 163, h_max: 164.9, w_map: [[40, 63.9, 34], [64, 72.4, 36], [72.5, 80.9, 38], [81, 89.4, 40], [89.5, 97.4, 42], [97.5, 105.9, 44], [106, 114.9, 46], [115, 160, 48]] },
  { h_min: 165, h_max: 166.9, w_map: [[40, 62.9, 34], [63, 71.9, 36], [72, 79.9, 38], [80, 88.4, 40], [88.5, 96.4, 42], [96.5, 104.9, 44], [105, 113.9, 46], [114, 160, 48]] },
  { h_min: 167, h_max: 168.9, w_map: [[40, 61.9, 34], [62, 70.9, 36], [71, 78.9, 38], [79, 87.4, 40], [87.5, 95.4, 42], [95.5, 103.9, 44], [104, 112.9, 46], [113, 160, 48]] },
  { h_min: 169, h_max: 170.9, w_map: [[40, 60.9, 34], [61, 69.9, 36], [70, 77.9, 38], [78, 86.9, 40], [87, 94.9, 42], [95, 102.9, 44], [103, 111.9, 46], [112, 160, 48]] },
  { h_min: 171, h_max: 172.9, w_map: [[40, 60.4, 34], [60.5, 68.9, 36], [69, 77.4, 38], [77.5, 85.9, 40], [86, 93.9, 42], [94, 102.4, 44], [102.5, 111.4, 46], [111.5, 160, 48]] },
  { h_min: 173, h_max: 174.9, w_map: [[40, 59.4, 34], [59.5, 67.9, 36], [68, 76.4, 38], [76.5, 84.9, 40], [85, 92.9, 42], [93, 101.4, 44], [101.5, 110.4, 46], [110.5, 160, 48]] },
  { h_min: 175, h_max: 176.9, w_map: [[40, 58.4, 34], [58.5, 66.9, 36], [67, 75.4, 38], [75.5, 83.9, 40], [84, 91.9, 42], [92, 100.4, 44], [100.5, 109.4, 46], [109.5, 160, 48]] },
  { h_min: 177, h_max: 178.9, w_map: [[40, 57.4, 34], [57.5, 66.4, 36], [66.5, 74.4, 38], [74.5, 82.9, 40], [83, 90.9, 42], [91, 99.4, 44], [99.5, 108.4, 46], [108.5, 160, 48]] },
  { h_min: 179, h_max: 180.9, w_map: [[40, 56.9, 34], [57, 65.4, 36], [65.5, 73.9, 38], [74, 81.9, 40], [82, 89.9, 42], [90, 98.9, 44], [99, 107.9, 46], [108, 160, 48]] },
  { h_min: 181, h_max: 182.9, w_map: [[40, 55.9, 34], [56, 64.4, 36], [64.5, 72.9, 38], [73, 81.4, 40], [81.5, 89.4, 42], [89.5, 97.9, 44], [98, 106.9, 46], [107, 160, 48]] },
  { h_min: 183, h_max: 184.9, w_map: [[40, 54.9, 34], [55, 63.4, 36], [63.5, 71.9, 38], [72, 80.4, 40], [80.5, 88.4, 42], [88.5, 96.9, 44], [97, 105.9, 46], [106, 160, 48]] },
  { h_min: 185, h_max: 186.9, w_map: [[40, 53.9, 34], [54, 62.9, 36], [63, 70.9, 38], [71, 79.4, 40], [79.5, 87.4, 42], [87.5, 95.9, 44], [96, 104.9, 46], [105, 160, 48]] },
  { h_min: 187, h_max: 188.9, w_map: [[40, 52.9, 34], [53, 61.9, 36], [62, 69.9, 38], [70, 78.4, 40], [78.5, 86.4, 42], [86.5, 94.9, 44], [95, 103.9, 46], [104, 160, 48]] },
  { h_min: 189, h_max: 190.9, w_map: [[40, 51.9, 34], [52, 60.9, 36], [61, 68.9, 38], [69, 77.9, 40], [78, 85.9, 42], [86, 93.9, 44], [94, 102.9, 46], [103, 160, 48]] },
  { h_min: 191, h_max: 192.9, w_map: [[40, 51.4, 34], [51.5, 59.9, 36], [60, 68.4, 38], [68.5, 76.9, 40], [77, 84.9, 42], [85, 93.4, 44], [93.5, 102.4, 46], [102.5, 160, 48]] },
  { h_min: 193, h_max: 194.9, w_map: [[40, 50.4, 34], [50.5, 58.9, 36], [59, 67.4, 38], [67.5, 75.9, 40], [76, 83.9, 42], [84, 92.4, 44], [92.5, 101.4, 46], [101.5, 160, 48]] },
  { h_min: 195, h_max: 196.9, w_map: [[40, 49.4, 34], [49.5, 57.9, 36], [58, 66.4, 38], [66.5, 74.9, 40], [75, 82.9, 42], [83, 91.4, 44], [91.5, 100.4, 46], [100.5, 160, 48]] },
  { h_min: 197, h_max: 198.9, w_map: [[40, 48.4, 34], [48.5, 57.4, 36], [57.5, 65.4, 38], [65.5, 73.9, 40], [74, 81.9, 42], [82, 90.4, 44], [90.5, 99.4, 46], [99.5, 160, 48]] },
  { h_min: 199, h_max: 200.9, w_map: [[40, 47.9, 34], [48, 56.4, 36], [56.5, 64.9, 38], [65, 72.9, 40], [73, 80.9, 42], [81, 89.9, 44], [90, 98.9, 46], [99, 160, 48]] },
];

var BH_SIZE_MAP = {
  34: "S", 36: "M", 38: "L", 40: "XL", 42: "2XL", 44: "3XL", 46: "4XL", 48: "5XL"
};

  // How far a model sits from what the grid predicts, in ladder steps. Positive = runs small.
var JACKET_MODEL_OFFSET = {
  "Cossack":      +1,   // 1/7 -> 5/7.  A return note says it outright: "the piece itself is made small"
  "Type 3":       +1    // 3/8 -> 5/8.  All three returns were "the sleeves bind" / too small
  // "Single Sport" -1 and "Archetype" -1 used to sit here. Both were measured against shipped alpha
  // sizes read through the default 34 = S ladder, and both models label their sizes one step up
  // (S is a US 36), so the "-1" was the ladder, not the cut. JACKET_LABEL_BASE below carries it now
  // and gives the same answer on every input; it also reaches J-24, Motorist and G-1, which the
  // offset never did (2026-09-13: J-24 183cm/74kg came out XL, the product's own chart says L).
};

  // Which US number each model calls "S" (34 unless listed). Labels are read on this ladder.
var JACKET_LABEL_BASE = {
  "J-24":         36,
  "Motorist":     36,
  "Archetype":    36,
  "Single Sport": 36,   // both "Single Sport Leather Jacket" and "1940s California Single Sport Jacket"
  "G-1":          36
};
  var JACKET_LABELS = ["S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL"];

  var US_LADDER = [34, 36, 38, 40, 42, 44, 46, 48];
  var ALPHA_US = { "S": 34, "M": 36, "L": 38, "XL": 40, "2XL": 42, "3XL": 44, "4XL": 46, "5XL": 48 };

  // Height/weight -> US size. Clamps at the edges instead of returning null (the bands stop at
  // .9, so 167.95cm would otherwise fall between two rows). `clamped` marks an edge answer.
  function getChartSize_(h, w) {
    if (!isFinite(h) || !isFinite(w)) return null;
    var clamped = false, i;
    var row = null;
    for (i = 0; i < JACKET_HW_TABLE.length; i++) { if (h >= JACKET_HW_TABLE[i].h_min && h <= JACKET_HW_TABLE[i].h_max) { row = JACKET_HW_TABLE[i]; break; } }
    if (!row) {
      var first = JACKET_HW_TABLE[0], last = JACKET_HW_TABLE[JACKET_HW_TABLE.length - 1];
      if (h < first.h_min) { row = first; clamped = true; }
      else if (h > last.h_max) { row = last; clamped = true; }
      else { for (i = 0; i < JACKET_HW_TABLE.length; i++) { if (JACKET_HW_TABLE[i].h_min > h) { row = JACKET_HW_TABLE[i]; break; } } if (!row) row = last; }
    }
    var cell = null;
    for (i = 0; i < row.w_map.length; i++) { if (w >= row.w_map[i][0] && w <= row.w_map[i][1]) { cell = row.w_map[i]; break; } }
    if (!cell) {
      var lo = row.w_map[0], hi = row.w_map[row.w_map.length - 1];
      if (w < lo[0]) { cell = lo; clamped = true; }
      else if (w > hi[1]) { cell = hi; clamped = true; }
      else { for (i = 0; i < row.w_map.length; i++) { if (row.w_map[i][0] > w) { cell = row.w_map[i]; break; } } if (!cell) cell = hi; }
    }
    return { us: cell[2], clamped: clamped };
  }
  // Title substring match, same as the engine: one model ships under several product ids
  // (pre-order, sale, each leather colour), but the model name is always in the title.
  function getJacketModelOffset_(title) {
    var t = String(title || "").toLowerCase();
    if (!t) return 0;
    for (var k in JACKET_MODEL_OFFSET) { if (JACKET_MODEL_OFFSET.hasOwnProperty(k) && t.indexOf(k.toLowerCase()) !== -1) return JACKET_MODEL_OFFSET[k]; }
    return 0;
  }
  function shiftJacketUsSize_(us, steps) {
    if (!steps) return us;
    var i = US_LADDER.indexOf(Number(us));
    if (i === -1) return us;
    return US_LADDER[Math.max(0, Math.min(US_LADDER.length - 1, i + steps))];
  }
  function ladderIndex_(us) { return US_LADDER.indexOf(Number(us)); }
  function getJacketLabelBase_(title) {
    var t = String(title || "").toLowerCase();
    if (!t) return 34;
    for (var k in JACKET_LABEL_BASE) { if (JACKET_LABEL_BASE.hasOwnProperty(k) && t.indexOf(k.toLowerCase()) !== -1) return JACKET_LABEL_BASE[k]; }
    return 34;
  }
  // Index into JACKET_LABELS for a US number on this model's ladder, clamped to S..5XL.
  function labelIndexForUs_(us, title) {
    var i = Math.round((Number(us) - getJacketLabelBase_(title)) / 2);
    return Math.max(0, Math.min(JACKET_LABELS.length - 1, i));
  }
  function jacketLabelForUs_(us, title) { return JACKET_LABELS[labelIndexForUs_(us, title)]; }

  // Pure recommendation. usualAlpha is "" or one of ALPHA_US keys.
  // Returns { us, label, chartUs, offset, clamped, refUs, gap } or null when inputs are missing.
  function recommend(heightCm, weightKg, usualAlpha, productTitle) {
    var h = parseFloat(heightCm), w = parseFloat(weightKg);
    if (!isFinite(h) || !isFinite(w) || h <= 0 || w <= 0) return null;
    var chart = getChartSize_(h, w);
    if (!chart) return null;
    var offset = getJacketModelOffset_(productTitle);
    var us = shiftJacketUsSize_(chart.us, offset);
    // The usual size is what they wear elsewhere, so it is read on the default ladder (S = 34);
    // the gap is measured in fit steps (US numbers), not in labels.
    var refUs = usualAlpha && ALPHA_US.hasOwnProperty(usualAlpha) ? ALPHA_US[usualAlpha] : null;
    var gap = refUs == null ? null : Math.abs(ladderIndex_(refUs) - ladderIndex_(us));
    var base = getJacketLabelBase_(productTitle);
    return { us: us, label: jacketLabelForUs_(us, productTitle), labelIndex: labelIndexForUs_(us, productTitle),
             defaultLabel: BH_SIZE_MAP[us] || String(us), base: base, shifted: base !== 34,
             chartUs: chart.us, chartLabel: jacketLabelForUs_(chart.us, productTitle),
             offset: offset, clamped: chart.clamped, refUs: refUs, refLabel: usualAlpha || "",
             refLabelHere: refUs == null ? "" : jacketLabelForUs_(refUs, productTitle), gap: gap };
  }

  // ======================= UNITS =======================
  var KG_PER_LB = 0.45359237;
  function heightToCm_(mode, ft, inch, cm) {
    if (mode === "cm") { var c = parseFloat(String(cm).replace(",", ".")); return isFinite(c) ? c : null; }
    var f = parseFloat(ft), n = parseFloat(inch === "" ? "0" : inch);
    if (!isFinite(f)) return null;
    if (!isFinite(n)) n = 0;
    return Math.round((f * 12 + n) * 2.54 * 10) / 10;
  }
  function weightToKg_(val, unit) {
    var n = parseFloat(String(val).replace(",", "."));
    if (!isFinite(n) || n <= 0) return null;
    return unit === "lb" ? Math.round(n * KG_PER_LB * 10) / 10 : n;
  }
  var HEIGHT_OK = [120, 230], WEIGHT_OK = [30, 250];

  // ======================= DOM =======================
  // Model list for the Size Guide (no product context). Only the name matters: the fit offset
  // keys off the title. Colour variants and "(sale)" listings collapse into one entry.
  var MODEL_OPTIONS = [
    "A-1 Flight Leather Jacket", "A-2 Leather Jacket", "\"Archetype\" 1930s D-Pocket Motorcycle Jacket",
    "B-3 Shearling Bomber Jacket", "Beltless Double Rider Jacket", "BLACKRIDGE Leather Motorcycle Jacket",
    "Brakeman Leather Car Coat", "California Highway Patrol Leather Jacket", "1940s California Bears Car Coat",
    "1940s California Single Sport Jacket", "Cossack Leather Jacket", "Four Corner Leather Work Jacket",
    "G-1 Aviation Flight Leather Jacket", "Grizzly Shearling Leather Jacket", "Half Belt Single Leather Jacket",
    "J-24 Leather Jacket With Mouton Collar", "J-31 Leather Motorcycle Jacket", "J-100 Single Rider Racing Jacket",
    "\"LA BREA\" 1930s D-Pocket Motorcycle Jacket", "“Motorist” 1930s Leather Sports Jacket",
    "Mulholland Leather Motorcycle Jacket", "One Star Motorcycle Jacket", "Record Breaker Motorcycle Leather Jacket",
    "San Mateo Leather Jacket", "Single Sport Leather Jacket", "Storm Rider Leather Jacket",
    "Type 3 Leather Jacket", "1930s Cropped Single Leather Jacket", "1960s Flat Track Leather Racing Jacket"
  ];

  // Same chip discovery as the boot widget: chips first, native <select> as a fallback.
  function findSizeControl() {
    var scope = document.querySelector('[data-wair-option-name="Size"]') || document;
    var chips = scope.querySelectorAll("button.dynamic-variant-button[data-option-value], button.product__chip[data-option-value]");
    if (chips.length) return { type: "chips", els: Array.prototype.slice.call(chips) };
    var select = scope.querySelector('select[name^="options"], select.dynamic-variant-input');
    if (select) return { type: "select", el: select };
    return null;
  }
  // Alpha options this product sells, in label order. Labels are compared by their position in
  // JACKET_LABELS, which is what the chips show, so the model's ladder is already baked in.
  function readSizeOptions(control) {
    var out = [];
    if (!control) return out;
    function push(value, el) {
      var key = String(value).trim().toUpperCase();
      var idx = JACKET_LABELS.indexOf(key);
      if (idx !== -1) out.push({ value: value, key: key, idx: idx, el: el || null });
    }
    if (control.type === "select") Array.prototype.forEach.call(control.el.options, function (o) { push(o.value); });
    else control.els.forEach(function (b) { push(b.getAttribute("data-option-value") || b.textContent, b); });
    out.sort(function (a, b) { return a.idx - b.idx; });
    return out;
  }
  // Nearest sellable size. Exact match first; otherwise closest label, tie -> larger.
  function snapToOption(labelIndex, options) {
    if (!options.length) return null;
    var best = null, bestD = Infinity;
    options.forEach(function (o) {
      var d = Math.abs(o.idx - labelIndex);
      if (d < bestD || (d === bestD && best && o.idx > best.idx)) { best = o; bestD = d; }
    });
    return best;
  }
  function applySelection(control, option) {
    if (!control || !option) return;
    if (control.type === "select") { control.el.value = option.value; control.el.dispatchEvent(new Event("change", { bubbles: true })); }
    else if (option.el) option.el.click();
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  function init(root) {
    var standalone = root.hasAttribute("data-bhjs-standalone");
    var productTitle = root.getAttribute("data-product-title") || "";
    var modelSelect = root.querySelector("[data-bhjs-model]");
    if (modelSelect && !modelSelect.getAttribute("data-bhjs-filled")) {
      MODEL_OPTIONS.forEach(function (name) { var o = document.createElement("option"); o.value = name; o.textContent = name; modelSelect.appendChild(o); });
      modelSelect.setAttribute("data-bhjs-filled", "1");
    }
    function currentTitle() { return modelSelect ? (modelSelect.value || "") : productTitle; }

    var relSel = root.getAttribute("data-bhjs-relocate");
    if (relSel) { var anchor = document.querySelector(relSel); if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(root, anchor.nextSibling); }

    var ftSel = root.querySelector("[data-bhjs-ft]"), inSel = root.querySelector("[data-bhjs-in]"), cmInput = root.querySelector("[data-bhjs-cm]");
    var ftinBox = root.querySelector("[data-bhjs-height-ftin]"), cmBox = root.querySelector("[data-bhjs-height-cm]"), hToggle = root.querySelector("[data-bhjs-height-toggle]");
    var wInput = root.querySelector("[data-bhjs-weight]"), usualSelect = root.querySelector("[data-bhjs-usual]"), resultEl = root.querySelector("[data-bhjs-result]");
    if (!ftSel || !wInput || !resultEl) return;

    var hMode = "ftin";
    function setHeightMode(m) {
      hMode = m;
      if (ftinBox) ftinBox.style.display = m === "cm" ? "none" : "";
      if (cmBox) cmBox.style.display = m === "cm" ? "" : "none";
      if (hToggle) hToggle.textContent = m === "cm" ? "Enter in ft / in instead" : "Enter in cm instead";
      run();
    }
    if (hToggle) hToggle.addEventListener("click", function () { setHeightMode(hMode === "cm" ? "ftin" : "cm"); });

    var wUnit = "lb";
    var unitBtns = Array.prototype.slice.call(root.querySelectorAll("[data-bhjs-unit]"));
    function setWeightUnit(u) {
      wUnit = u;
      unitBtns.forEach(function (b) { var on = b.getAttribute("data-bhjs-unit") === u; b.classList.toggle("is-active", on); b.setAttribute("aria-pressed", on ? "true" : "false"); });
      wInput.placeholder = u === "lb" ? "e.g. 165" : "e.g. 75";
      run();
    }
    unitBtns.forEach(function (b) { b.addEventListener("click", function () { setWeightUnit(b.getAttribute("data-bhjs-unit")); }); });

    // Cart properties: what the shopper typed + what we told them, so CS can see both.
    function setCartProp_(form, key, value) {
      var input = form.querySelector('input[data-bhjs-prop="' + key + '"]');
      if (!value) { if (input && input.parentNode) input.parentNode.removeChild(input); return; }
      if (!input) { input = document.createElement("input"); input.type = "hidden"; input.name = "properties[" + key + "]"; input.setAttribute("data-bhjs-prop", key); form.appendChild(input); }
      input.value = value;
    }
    function cartForm_() { return root.closest('form[action*="/cart"]') || document.querySelector('form[action*="/cart/add"]'); }
    function syncCartProps_(hCm, wKg, usual) {
      if (standalone) return;
      var form = cartForm_(); if (!form) return;
      setCartProp_(form, "_height_cm", hCm != null ? String(hCm) : "");
      setCartProp_(form, "_weight_kg", wKg != null ? String(wKg) : "");
      setCartProp_(form, "_usual_jacket_size", usual || "");
      setCartProp_(form, "_recommended_size", "");
      setCartProp_(form, "_fit_check", "");
    }
    function recOut_(size, verdict) {
      if (standalone) return;
      var form = cartForm_(); if (!form) return;
      setCartProp_(form, "_recommended_size", size ? String(size) : "");
      setCartProp_(form, "_fit_check", verdict || "");
    }

    function render(cls, html) { resultEl.className = "bhsr__result " + cls; resultEl.innerHTML = html; }

    function run() {
      var hCm = heightToCm_(hMode, ftSel.value, inSel ? inSel.value : "", cmInput ? cmInput.value : "");
      var wKg = weightToKg_(wInput.value, wUnit);
      var usual = usualSelect ? String(usualSelect.value || "").toUpperCase() : "";
      syncCartProps_(hCm, wKg, usual);

      if (hCm == null || wKg == null) { render("", ""); return; }
      if (hCm < HEIGHT_OK[0] || hCm > HEIGHT_OK[1] || wKg < WEIGHT_OK[0] || wKg > WEIGHT_OK[1]) {
        render("bhsr__result--warn", '<div class="bhsr__size">Let’s double-check those numbers.</div><div class="bhsr__note">Please check your height and weight, and the units (cm or ft / in, kg or lb).</div>');
        recOut_("", "implausible height/weight");
        return;
      }

      var rec = recommend(hCm, wKg, usual, currentTitle());
      if (!rec) { render("", ""); return; }

      var control = standalone ? null : findSizeControl();
      var options = standalone ? [] : readSizeOptions(control);
      var snap = options.length ? snapToOption(rec.labelIndex, options) : null;
      var shown = snap ? snap.key : rec.label;
      var offRange = snap && snap.idx !== rec.labelIndex;   // wanted a size this product does not sell
      var lines = [];

      // Heading
      if (rec.refUs != null && rec.gap === 0 && !offRange) {
        lines.push('<div class="bhsr__size"><strong>' + esc(shown) + "</strong> is your size.</div>");
        lines.push('<div class="bhsr__note">Your usual size and your height and weight point the same way' + (rec.shifted && rec.label !== rec.refLabel ? ", and on this jacket that fit is labelled " + esc(rec.label) + " rather than " + esc(rec.refLabel) : "") + ".</div>");
      } else {
        lines.push('<div class="bhsr__size">We recommend <strong>' + esc(shown) + "</strong>.</div>");
      }

      // Ladder note: this model's labels sit one step up from the rest of the range.
      if (rec.shifted) {
        lines.push('<div class="bhsr__note">This model is graded one label up from our other jackets (its S is what most of them call M), so the size you wear elsewhere may read one label smaller here.</div>');
      }

      // Model fit note
      if (rec.offset) {
        lines.push('<div class="bhsr__note">This model ' + (rec.offset > 0 ? "runs small, so this is one size up" : "runs roomy, so this is one size down") + " from our standard chart.</div>");
      }

      // Sold-range note (chart wanted a size the product does not carry)
      if (offRange) {
        var lo = options[0].key, hi = options[options.length - 1].key;
        var above = rec.labelIndex > snap.idx;
        lines.push('<div class="bhsr__note">This jacket comes in ' + esc(lo) + " to " + esc(hi) + ". Your numbers sit " + (above ? "above" : "below") + " that range, so " + esc(shown) + " is the closest we make" + (above ? ", and it may be snug" : ", and it may be roomy") + ". Please ask us before ordering and we’ll check the measurements with you.</div>");
      }

      // Usual-size disagreement
      var cls = "bhsr__result--ok", verdict = "by height/weight";
      if (rec.refUs != null && rec.gap === 0) {
        verdict = "aligned: usual and chart agree";
      } else if (rec.refUs != null && rec.gap === 1) {
        var dir = rec.refUs < rec.us ? "up" : "down";
        lines.push('<div class="bhsr__note">You usually wear ' + esc(rec.refLabel) + "; on this jacket your height and weight come out one size " + dir + (rec.shifted ? ", which is " + esc(rec.label) + " here" : "") + ". If you prefer a " + (dir === "up" ? "closer" : "roomier") + " fit, " + esc(rec.refLabelHere) + " will also work.</div>");
        verdict = "1 step off: usual " + rec.refLabel + " vs chart " + rec.label + (rec.shifted ? " (US " + rec.us + ", this model labels a US 36 as S)" : "");
      } else if (rec.refUs != null && rec.gap >= 2) {
        lines.push('<div class="bhsr__note">You usually wear ' + esc(rec.refLabel) + ", which is quite far from what your height and weight suggest. Please double-check the numbers and units, or ask us and we’ll size you by hand.</div>");
        cls = "bhsr__result--warn";
        verdict = "MISMATCH: usual " + rec.refLabel + " vs chart " + rec.label + (rec.shifted ? " (US " + rec.us + ", this model labels a US 36 as S)" : "");
      }

      if (rec.clamped) lines.push('<div class="bhsr__note bhsr__note--soft">Your height or weight is outside our chart, so treat this as an estimate.</div>');

      render(cls, lines.join(""));
      if (control && snap) applySelection(control, snap);
      recOut_(shown, verdict);
    }

    [ftSel, inSel, cmInput, wInput, usualSelect, modelSelect].forEach(function (el) {
      if (!el) return;
      el.addEventListener("change", run);
      el.addEventListener("input", run);
    });
    setWeightUnit("lb");
    setHeightMode("ftin");
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-bhjs-root]"), function (r) {
      if (r.getAttribute("data-bhjs-ready")) return;
      r.setAttribute("data-bhjs-ready", "1");
      init(r);
    });
  }

  if (typeof window !== "undefined") {
    window.BHJacketSizeRecommender = { recommend: recommend, chart: getChartSize_, offsetFor: getJacketModelOffset_, labelFor: jacketLabelForUs_, baseFor: getJacketLabelBase_ };
  }
  if (typeof document !== "undefined" && document.addEventListener) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
    document.addEventListener("shopify:section:load", boot);
  }
})();
